import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_69566509-b9c0-48ae-b149-6b9accd67eee/artifacts/3nmi4pqp_Dynamic%20Logo%20with%20Sapphire%20Coral%20Gradient%20%288%29.png";

const Cookies = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-primary)' }}>
      {/* Header */}
      <header className="nav">
        <div className="nav-content">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="Shadesense.ai" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="btn-secondary flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container py-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-meta uppercase tracking-widest mb-4" style={{ color: 'var(--accent-primary)' }}>
            Legal
          </p>
          <h1 className="text-display mb-4" style={{ color: 'var(--text-primary)' }}>
            Cookie Policy
          </h1>
          <p className="text-body text-secondary mb-12">
            Shadesense.ai
          </p>

          <div className="prose prose-lg" style={{ color: 'var(--text-secondary)' }}>
            <p className="text-body mb-8">
              Shadesense.ai uses cookies and similar technologies to ensure proper functionality and improve user experience.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>1. Types of Cookies We Use</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li className="text-body"><strong>Essential Cookies</strong> – required for basic site functionality</li>
              <li className="text-body"><strong>Analytics Cookies</strong> – help us understand usage patterns</li>
              <li className="text-body"><strong>Preference Cookies</strong> – remember user settings</li>
            </ul>
            <p className="text-body mb-4">
              Third-party cookies may be set by analytics providers and affiliate platforms.
            </p>
            <p className="text-body mb-6">
              Affiliate cookies are set only when a user voluntarily clicks a product link.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>2. Cookie Consent</h2>
            <p className="text-body mb-6">
              By continuing to use the Service after seeing the cookie banner, you consent to our use of cookies. You may manage cookies through your browser settings.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>3. Changes</h2>
            <p className="text-body mb-6">
              This Cookie Policy may be updated periodically.
            </p>
          </div>

          {/* Other Legal Links */}
          <div className="mt-16 pt-8" style={{ borderTop: '1px solid var(--border-subtle)' }}>
            <p className="text-small text-muted mb-4">Related Policies</p>
            <div className="flex flex-wrap gap-4">
              <Link to="/terms" className="text-small hover:underline" style={{ color: 'var(--accent-primary)' }}>Terms of Use</Link>
              <Link to="/privacy" className="text-small hover:underline" style={{ color: 'var(--accent-primary)' }}>Privacy Policy</Link>
              <Link to="/policies" className="text-small hover:underline" style={{ color: 'var(--accent-primary)' }}>All Policies</Link>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="text-meta text-muted">© 2026 Shadesense Inc. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Cookies;
